import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { LoggingApplicationInsightsService } from '../../services/logging-application-insights/logging-application-insights.service';

export interface SaveChangesDialogData {
  text: string;
  title: string;
  saveButton?: string;
  discardButton?: string;
}

export enum SaveChangesResult {
  Save = 'save',
  Discard = 'discard',
  Cancel = 'cancel'
}

@Component({
  selector: 'app-save-changes-dialog',
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule, MatIconModule],
  templateUrl: './save-changes-dialog.component.html',
  styleUrl: './save-changes-dialog.component.scss'
})
export class SaveChangesDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SaveChangesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SaveChangesDialogData,
    private loggingApplicationInsights: LoggingApplicationInsightsService
  ) { }

  ngOnInit(): void {
    this.loggingApplicationInsights.logTrace(`Dialog opened`, { origin: this.constructor.name });
  }

  onSave() {
    this.dialogRef.close(SaveChangesResult.Save);
  }

  onDiscard() {
    this.dialogRef.close(SaveChangesResult.Discard);
  }

  onCancel() {
    this.dialogRef.close(SaveChangesResult.Cancel);
  }
}
